import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { heroIncludes, MOCKUP_IMAGE } from '../data/content';
export function Hero() {
  return <header className="bg-ink" data-id="element-164" data-mp="9l357ep60g51">
      <div className="bg-signal px-4 py-2.5 text-center text-[13px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-165" data-mp="4lql31pohn65">
        Launch offer · $27 one-time · Ends in <CountdownTimer variant="inline" data-id="element-166" data-mp="128pijeo72z53" />
      </div>

      <div className="mx-auto grid max-w-6xl gap-8 px-4 pb-14 pt-10 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12 lg:pt-16" data-id="element-167" data-mp="x9un9d91ji43">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:text-left" data-id="element-168" data-mp="s9q6rn84undv">
          <p className="mb-4 inline-flex items-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-amber sm:text-xl" data-id="element-169" data-mp="nb6lzq59zhn3">
            <ZapIcon className="h-5 w-5" aria-hidden="true" data-id="element-170" data-mp="3czfm01cr0b73" />
            Stop guessing what fault codes mean
          </p>
          <h1 className="font-display text-[44px] font-extrabold uppercase leading-[0.98] text-white sm:text-6xl lg:text-[68px]" data-id="element-171" data-mp="3j8sdfvbir9n7">
            Turn confusing OBD2 fault codes into a{' '}
            <span className="text-amber" data-id="element-172" data-mp="3o59a5dwsawbw">clear, step-by-step diagnostic plan</span>
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-mist sm:text-xl" data-id="element-173" data-mp="39cpain8uf6z7">
            So you know exactly <strong className="text-white" data-id="element-174" data-mp="3eb91x367hayy">what to check next.</strong> Learn to interpret
            trouble codes, understand live data, investigate possible causes, and organize your next steps
            with a structured troubleshooting system.
          </p>
        </div>

        <div className="-mx-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mx-0" data-id="element-175" data-mp="2qlogmdmky1mi">
          <img src={MOCKUP_IMAGE} alt="OBD2 Diagnostic Blueprint collection: 6 volumes, 5 bonus books, roadmaps and checklists" className="w-full" data-id="element-176" data-mp="2vjpvsngvxgsp" />
        </div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-177" data-mp="2lk8qw89gj6xs">
          <div className="rounded-2xl border border-line bg-panel p-5 sm:p-6" data-id="element-178" data-mp="s2joo1a4k8lm">
            <p className="font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-179" data-mp="nbb9spq0zv12">
              6 Professional Volumes <span className="text-amber" data-id="element-180" data-mp="ibgn6yda9rlt">+ 5 Exclusive Toolkits</span>
            </p>
            <ul className="mt-4 grid gap-x-5 gap-y-2.5 sm:grid-cols-2" data-id="element-181" data-mp="ddnhs7jt11ml">
              {heroIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white" data-id="element-182" data-mp="1azuktd0gmlwu">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ok" data-id="element-183" data-mp="161jcj6ptcjgq">
                    <CheckIcon className="h-3.5 w-3.5 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-184" data-mp="111esx7tlz8ma" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="mt-8 space-y-8" data-id="element-185" data-mp="3lu9wv02xxwap">
            <CtaButton id="first-cta" label="Yes! I want the Blueprint" sub="Instant Digital Access · One-Time Payment of $27 · Lifetime Access" data-id="element-186" data-mp="3hrllakmueba1" />
            <CountdownTimer data-id="element-187" data-mp="21amtp33s7gj6" />
          </div>

          <p className="mt-6 text-center text-sm text-mist lg:text-left" data-id="element-188" data-mp="21bft1j0ev3ra">
            Created by automotive electronics specialist <strong className="text-white" data-id="element-189" data-mp="267wj4ir67s70">Jason Mitchell</strong>.
          </p>
        </div>
      </div>
    </header>;
}